import { render, staticRenderFns } from "./fbpMapping.vue?vue&type=template&id=02f76ffc&scoped=true"
import script from "./fbpMapping.vue?vue&type=script&lang=js"
export * from "./fbpMapping.vue?vue&type=script&lang=js"
import style0 from "./fbpMapping.vue?vue&type=style&index=0&id=02f76ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f76ffc",
  null
  
)

export default component.exports